<button mat-raised-button class="button" [type]="type" [ngStyle]="{ margin: marginVertical + 'px ' + marginHorizontal + 'px' }" [disabled]="disabled" [routerLink]="pageToRedirect">{{text}}</button>
